export const AlertsIcon = (_p: React.ComponentProps<"svg">) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Bell"
  >
    <path
      d="M8 1.50254C7.67344 1.50254 7.41071 1.77417 7.41071 2.11179V2.35804C5.41205 2.65251 3.875 4.43204 3.875 6.57967V6.94776C3.875 7.9048 3.62946 8.84407 3.16295 9.67165L2.62522 10.6211C2.5442 10.7683 2.5 10.9333 2.5 11.1034C2.5 11.634 2.91496 12.063 3.42813 12.063H12.5719C13.085 12.063 13.5 11.634 13.5 11.1034C13.5 10.9333 13.4558 10.7658 13.3748 10.6211L12.8371 9.66911C12.3705 8.84154 12.125 7.90227 12.125 6.94523V6.57713C12.125 4.42951 10.5879 2.64997 8.58929 2.3555V2.10926C8.58929 1.77163 8.32656 1.5 8 1.5V1.50254ZM12.1348 10.8445H3.86272L4.17946 10.2834C4.75156 9.27055 5.05357 8.11804 5.05357 6.94776V6.57967C5.05357 4.8966 6.3721 3.53339 8 3.53339C9.6279 3.53339 10.9464 4.8966 10.9464 6.57967V6.94776C10.9464 8.12058 11.2484 9.27055 11.8181 10.2834L12.1348 10.8445ZM6.33281 13.2815C6.57589 13.9923 7.23147 14.5 8 14.5C8.76853 14.5 9.42411 13.9923 9.66719 13.2815H6.33281Z"
      fill="currentColor"
    />
  </svg>
);
